const TEXTKEYLOCALSTORAGE = 'packingList'
const TEXTKEYRELACIONDESPACHO = 'relacionDespacho'

export const state = {
  packingList: JSON.parse(localStorage.getItem(TEXTKEYLOCALSTORAGE)) || {
    active: false,
    products: []
  },
  relacionDespacho: JSON.parse(localStorage.getItem(TEXTKEYRELACIONDESPACHO)) || {
    active: false,
    guides: [],
    conveyor: null
  }
}

export const mutations = {
  setStatusPackingList(state, value){
    state.packingList.active = value
    const local = JSON.parse(localStorage.getItem(TEXTKEYLOCALSTORAGE))
    local.active = value
    localStorage.setItem(TEXTKEYLOCALSTORAGE, JSON.stringify(local))
  },
  SET_PRODUCTS(state, products){
    for(let product of products){
      const index = state.packingList.products.findIndex(p => p.sku === product.sku)
      if(index === -1){
        state.packingList.products.push(product)
      }else{
        const productState = state.packingList.products[index]
        const quantity = productState.quantity + product.quantity
        const updateProduct = {
          ...productState,
          quantity: quantity
        }
        state.packingList.products.splice(index, 1, updateProduct)
      }
    }
    updateLocalStorageProducts(state.packingList.products)
  },
  RESET_PACKING_LIST(state){
    state.packingList ={
      active: false,
      products: []
    }
  },
  SET_STATUS_RELACION_DESPACHO(state, value){
    state.relacionDespacho.active = value
    const local = JSON.parse(localStorage.getItem(TEXTKEYRELACIONDESPACHO))
    local.active = value
    localStorage.setItem(TEXTKEYRELACIONDESPACHO, JSON.stringify(local))
  },
  SET_CONVEYOR_RELACION_DESPACHO(state, value){
    state.relacionDespacho.conveyor = value
    const local = JSON.parse(localStorage.getItem(TEXTKEYRELACIONDESPACHO))
    local.conveyor = value
    localStorage.setItem(TEXTKEYRELACIONDESPACHO, JSON.stringify(local))
  },
  SET_GUIDE_RELACION_DESPACHO(state, value){
    state.relacionDespacho.guides.push(value)
    const local = JSON.parse(localStorage.getItem(TEXTKEYRELACIONDESPACHO))
    local.guides = state.relacionDespacho.guides
    localStorage.setItem(TEXTKEYRELACIONDESPACHO, JSON.stringify(local))
  },
  RESET_RELACION_DESPACHO(state){
    state.relacionDespacho = {
      active: false,
      guides: [],
      conveyor: null
    }
    localStorage.setItem(TEXTKEYRELACIONDESPACHO, JSON.stringify(state.relacionDespacho))
  }
}

export const actions = {
  addProductsPacking({ commit }, products){
    commit('SET_PRODUCTS', products)
  },
  resetPackingList({ commit }){
    commit('RESET_PACKING_LIST')
  },
  addGuideRelacionDespacho({ commit }, guide){
    commit('SET_GUIDE_RELACION_DESPACHO', guide)
  },
  addConveyorRelacionDespacho({ commit }, value){
    commit('SET_CONVEYOR_RELACION_DESPACHO', value)
  },
  resetRelacionDespacho({ commit }){
    commit('RESET_RELACION_DESPACHO')
  }
}

export const getters = {
  statusPackingList(state){
    return state.packingList.active
  },
  hasProducts(state){
    return state.packingList.products.length > 0
  },
  statusRelacionDespacho(state){
    return state.relacionDespacho.active
  },
  hasGuidesRelacionDespacho(state){
    return state.relacionDespacho.guides.length > 0
  },
  getConveyorName(state){
    return state.relacionDespacho.conveyor
  }
}

const updateLocalStorageProducts = (products) => {
  const local = JSON.parse(localStorage.getItem(TEXTKEYLOCALSTORAGE))
  local.products = products
  localStorage.setItem(TEXTKEYLOCALSTORAGE, JSON.stringify(local))
}